module.exports = __webpack_public_path__ + "img/Page-1.6021c096.svg";